import { inject, computed, ref } from 'vue'
import { format } from 'date-fns'

export function useDate() {
    const date = inject('date', ref(new Date()))
    const formattedDate = computed(() => format(date.value, 'yyyy-MM-dd'))

    return {
        date,
        formattedDate
    }
}